export default __webpack_public_path__ + "close_x.svg";